import { useEffect, useRef, useState, ChangeEvent, ComponentProps } from 'react';
import { useSearchBox, UseSearchBoxProps } from 'react-instantsearch';
import debounce from 'lodash/debounce';
import router from 'next/router';
import { SEARCH_DEBOUNCE_TIME } from '@components/Search/const';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
import ControlledSearchBox from '../ControlledSearchBox/ControlledSearchBox';
export type PropsType = ComponentProps<'div'> & UseSearchBoxProps & {
  placeholder: string;
  setQuery: (query: string) => void;
  isSearchOpened?: boolean;
};
export function SearchBox(props: PropsType) {
  const {
    setQuery,
    isSearchOpened
  } = props;
  const {
    query,
    refine,
    clear
  } = useSearchBox(props);
  const [value, setValue] = useState(query);
  const [inputValue, setInputValue] = useState(query);
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    closeSearch,
    getRedirectSearchForm
  } = layoutUiState;
  const {
    className,
    placeholder
  } = props;
  const queryStringLengthNotFetch: number[] = [1, 2];
  const debouncedSearch = useRef(debounce(criteria => {
    if (criteria.length === 0) {
      setValue('');
      setQuery('');
      clear();
    } else {
      setValue(criteria);
      setQuery(criteria);
    }
  }, SEARCH_DEBOUNCE_TIME)).current;
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.currentTarget.value);
    debouncedSearch(event.currentTarget.value);
  };
  const onSubmit = () => {
    closeSearch();
    const redirectSearch = getRedirectSearchForm();
    if (typeof window !== 'undefined' && redirectSearch) {
      window.location.href = redirectSearch;
    } else {
      // Zachowaj parametry śledzenia Google Ads
      const currentParams = new URLSearchParams(window.location.search);
      const trackingParams: Record<string, string> = {};
      const trackingParamNames = ['gclid', 'glcid', 'gclsrc', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'msclkid', 'ref'];
      trackingParamNames.forEach(param => {
        const paramValue = currentParams.get(param);
        if (paramValue) {
          trackingParams[param] = paramValue;
        }
      });
      router.push({
        pathname: '/search/[slug]',
        query: {
          slug: encodeURI(inputValue),
          ...trackingParams
        }
      });
    }
  };
  useEffect(() => {
    if (query !== value && !queryStringLengthNotFetch.includes(value.length)) {
      refine(value);
    }
  }, [value, query, refine]);
  useEffect(() => () => {
    debouncedSearch.cancel();
  }, [debouncedSearch]);

  // Focus input when search is opened
  useEffect(() => {
    setQuery('');
    setInputValue('');
    if (isSearchOpened && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isSearchOpened]);
  return <ControlledSearchBox className={className} inputRef={inputRef} onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event)} onSubmit={onSubmit} placeholder={placeholder} value={inputValue} />;
}